import * as types from './users.types';
import * as constants from './users.constants';

export const initialUserPage = (): types.IInitialUserPage => ({
  type: constants.INITIAL_USER_PAGE,
});
